"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsDrop = void 0;
const utilsSQLite_1 = require("./utilsSQLite");
class UtilsDrop {
    constructor() {
        this.sqliteUtil = new utilsSQLite_1.UtilsSQLite();
    }
    /**
     * DropElements
     * @param db
     * @param type ["table","index","trigger"]
     */
    dropElements(db, type) {
        let msg = '';
        let stmt1 = `AND name NOT LIKE ('sqlite_%')`;
        switch (type) {
            case 'index':
                msg = 'DropIndexes';
                break;
            case 'trigger':
                msg = 'DropTriggers';
                break;
            case 'table':
                msg = 'DropTables';
                stmt1 += ` AND name NOT IN ('sync_table')`;
                break;
            case 'view':
                msg = 'DropViews';
                break;
            default:
                throw new Error(`DropElements: ${type} ` + 'not found');
        }
        // get the element's names
        let stmt = 'SELECT name FROM sqlite_master WHERE ';
        stmt += `type = '${type}' ${stmt1};`;
        try {
            const elements = this.sqliteUtil.queryAll(db, stmt, [], true);
            if (elements.length > 0) {
                const upType = type.toUpperCase();
                const statements = [];
                for (const elem of elements) {
                    let stmt = `DROP ${upType} IF EXISTS `;
                    stmt += `${elem.name};`;
                    statements.push(stmt);
                }
                for (const stmt of statements) {
                    const results = this.sqliteUtil.prepareRun(db, stmt, [], false, 'no');
                    if (results.lastId < 0) {
                        throw new Error(`${msg}: lastId < 0`);
                    }
                }
            }
            return;
        }
        catch (err) {
            throw new Error(`${msg}: ${err}`);
        }
    }
    /**
     * DropAll
     * Drop all database's elements
     * @param db
     */
    dropAll(db) {
        try {
            // drop tables
            this.dropElements(db, 'table');
            // drop indexes
            this.dropElements(db, 'index');
            // drop triggers
            this.dropElements(db, 'trigger');
            // drop views
            this.dropElements(db, 'view');
            // vacuum the database
            this.sqliteUtil.prepareRun(db, 'VACUUM;', [], false, 'no');
            return;
        }
        catch (err) {
            throw new Error(`DropAll: ${err}`);
        }
    }
    /**
     * DropTempTables
     * @param db
     * @param alterTables
     */
    dropTempTables(db, alterTables) {
        const tempTables = Object.keys(alterTables);
        const statements = [];
        for (const tTable of tempTables) {
            let stmt = 'DROP TABLE IF EXISTS ';
            stmt += `_temp_${tTable};`;
            statements.push(stmt);
        }
        try {
            const results = this.sqliteUtil.execute(db, statements.join('\n'), false, true);
            if (results.changes < 0) {
                throw new Error('DropTempTables: changes < 0');
            }
            return;
        }
        catch (err) {
            throw new Error(`DropTempTables: ${err}`);
        }
    }
}
exports.UtilsDrop = UtilsDrop;
//# sourceMappingURL=utilsDrop.js.map